import { useEffect, useState } from "react"
// import axios from "axios"
import Select, { MenuPlacement } from "react-select"
import { SelectedRecord } from "../../interfaces/selectedRecord"
import customStyles from "./styles"
import { useQuery } from "react-query"
import { betterFetch } from "utils/apis"
import DropdownIndicatorForSelect from "components/DropdownIndicatorForSelect"

const mapper = (label: any, preventBlend?: boolean) => (data: any) => {
  const products = (data.results ?? data ?? []).map((record: any) => ({
    id: record?.id,
    value: record?.id,
    label: label(record),
    data: record,
  }))
  if (!preventBlend) return products
  return products.filter((item: any) => !item?.data?.blended)
}

export const SingleSelect = (props: {
  selected?: number
  menuPlacement?: MenuPlacement
  onSelect: Function
  endpoint: string
  label: Function
  flush?: boolean
  returnDivIfNull?: boolean
  isDisabled?: boolean
  placeholder?: string
  isClearable?: boolean
  controlStyle?: any
  preventBlend?: boolean
  error?: { message: string | "" }
}) => {
  const [hide, setHide] = useState(false)
  const { data, isLoading } = useQuery<SelectedRecord[]>(
    props.endpoint,
    betterFetch(props.endpoint, {
      mapper: mapper(props.label, props.preventBlend),
    }),
    {
      cacheTime: 1000,
    }
  )

  useEffect(() => {
    setHide(true)
    setTimeout(() => {
      setHide(false)
    }, 2)
  }, [props.selected])

  if (isLoading || hide) return props.returnDivIfNull ? <div /> : null

  return (
    <Select
      menuPlacement={props?.menuPlacement ?? "auto"}
      isClearable={props.isClearable}
      components={
        props.error ? { DropdownIndicator: DropdownIndicatorForSelect } : {}
      }
      isDisabled={props.isDisabled}
      styles={customStyles({
        marginRight: props.flush ? 0 : 24,
        border: props.error?.message ? "1px solid #fa5c7c" : "",
        ...(props.controlStyle ?? {}),
      })}
      options={data}
      placeholder="Choose..."
      onChange={(value) => props.onSelect(value)}
      defaultValue={data?.filter((r: any) => props.selected === r.id)}
    />
  )
}
